import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CRMEntityDetails } from '../../../../models/common/CRMEntityDetails';

@Component({
  selector: 'app-crm-entity-details-popup',
  imports: [TranslatePipe],
  templateUrl: './crm-entity-details-popup.html',
  styleUrl: './crm-entity-details-popup.scss',
})
export class CrmEntityDetailsPopupComponent {
  @Input() title: string = '';
  @Input() rows: CRMEntityDetails[] = [];
}
